export class GeolocationInfo {
  constructor(
    public readonly latitude: string,
    public readonly longitude: string
    ) { }
}
